import React from 'react'
import { BiBarChart, BiShield, BiCog } from 'react-icons/bi'
import MobileFeatureCard from './MobileFeatureCard'

const MobileFeatures = () => (
    <div className="mt-8 grid grid-cols-3 gap-4 lg:hidden">
        <MobileFeatureCard icon={BiBarChart} title="Relatórios" color="text-indigo-600" />
        <MobileFeatureCard icon={BiShield} title="Segurança" color="text-green-600" />
        <MobileFeatureCard icon={BiCog} title="Automação" color="text-purple-600" />
    </div>
)

export default MobileFeatures